const pick = require('lodash/pick');
const assign = require('lodash/assign');
const find = require('lodash/find');
const getStatsHelpers = require('./get_stats_helpers.js');
const calculateFrameRate = require('./calculate-frame-rate.js');

const watchFrameRate = (getStats, delay = 5000) => {
  let timeoutId;
  let destroyed = false;
  const lastStat = {};

  const getVideoInboundStat = (stats = []) => (
    find(stats, stat => getStatsHelpers.isVideoInboundRtpStat(stat))
  );

  const query = () => {
    if (destroyed) {
      return;
    }
    getStats((error, stats) => {
      if (destroyed) {
        return;
      }

      if (!error) {
        const stat = getVideoInboundStat(stats);
        if (stat) {
          assign(lastStat, pick(stat, ['timestamp', 'framesDecoded']));
        } else if (!lastStat.timestamp) {
          assign(lastStat, {
            timestamp: Date.now(),
            framesDecoded: 0,
          });
        }
      }

      timeoutId = setTimeout(query, delay);
    });
  };

  query();

  return {
    getFrameRateFromStat(stat) {
      return calculateFrameRate({
        currentStatFrames: stat.framesDecoded,
        currentTimestamp: stat.timestamp,
        prevStatFrames: lastStat.framesDecoded,
        prevTimestamp: lastStat.timestamp,
      });
    },
    destroy() {
      destroyed = true;
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    },
  };
};

module.exports = watchFrameRate;
